export default "__VITE_ASSET__k47gnFuT__"